<template>
  <div id="page" class="container-fluid">
    <div class="row header mx-4 my-4">
      <div class="col my-3">
        <h1> {{ ascFeeScheduleCodes.feeScheduleName}}
          <b-button class="ml-3" variant="outline-orange" @click="addAscFeeScheduleCode()">
            <font-awesome-icon class="orange" icon="plus"/>
            New
          </b-button></h1>
      </div>
      <div class="row mt-3">
        <div class="patient-search-section">
        <b-input-group class="patient-search-border text-right">
          <b-form-input ref="searchInput"
                        placeholder="Search (Code)"
                        class="patient-search"
                        v-model="searchTerm">
          </b-form-input>
          <b-input-group-append>
            <button class="btn btn-default search-submit" type="button">
              <font-awesome-icon icon="search"/>
            </button>
          </b-input-group-append>
        </b-input-group>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row data-table-header">
        <div class="col-1">Code</div>
        <div class="col-1">Modifier</div>
        <div class="col-3">Description</div>
        <div class="col-2">Discount Eligible</div>
        <div class="col-2">Fee</div>
        <div class="col-3"></div>
      </div>
      <div v-for="ascFeeScheduleCode in filteredCodes" class="row data-table-row" :key="ascFeeScheduleCode.organizationAscFeeScheduleCodeId">
        <div class="column col-1">{{ ascFeeScheduleCode.code }}</div>
        <div class="column col-1">{{ ascFeeScheduleCode.modifier }}</div>
        <div class="column col-3">{{ ascFeeScheduleCode.description }}</div>
        <div class="column col-2">{{discountEligible(ascFeeScheduleCode.discountEligible)}}</div>
        <div class="column col-2">${{formatNumber(ascFeeScheduleCode.fee)}}</div>
        <div class="col-3 text-right">
          <button title="Edit" @click.prevent="editAscFeeScheduleCodes(ascFeeScheduleCode)" type="button" class="btn btn-outline-orange m-1 wide-button">
            <font-awesome-icon class="orange mr-2" :icon="['far', 'edit']"/>Edit
          </button>
          <button title="Delete" @click.prevent="confirmDelete(ascFeeScheduleCode.organizationAscFeeScheduleCodeId)" type="button" class="btn btn-outline-orange m-1 wide-button">
            <font-awesome-icon class="orange mr-2" :icon="['far', 'trash-alt']"/>Delete
          </button>
        </div>
      </div>
    </div>
    <asc-fee-schedule-codes-modal :asc-fee-schedule-id="id" :edit-asc-fee-schedule-code="editingAscFeeScheduleCode" @updated="ascFeeScheduleCodeUpdated" :visible="showingAscFeeScheduleCodeModal"
                             @update:visible="visible => showingAscFeeScheduleCodeModal = visible"></asc-fee-schedule-codes-modal>
    <confirm-modal :title="confirmTitle"
                   @confirmed="deleteConfirmed"
                   confirmButton="Delete"
                   :copy="confirmCopy"
                   :visible="showConfirmation"
                   @update:visible="visible => showConfirmation = visible"></confirm-modal>
    <loading-modal :visible="showingLoadingModal" :return-focus="$refs.searchInput"
                   @update:visible="visible => showingLoadingModal = visible"></loading-modal>
    <paginator :totalPages="totalPages" :currentPage="currentPage" @update:currentPage="newPage => currentPage = newPage"></paginator>
  </div>
</template>

<script>
  import api from '@/services/api'
  import ConfirmModal from '@/components/ConfirmModal'
  import ErrorsMixin from '@/mixins/ErrorsMixin'
  import Paginator from '@/components/Paginator'
  import AscFeeScheduleCodesModal from '@/components/AscFeeScheduleCodesModal'
  import LoadingModal from '@/components/LoadingModal'
  import _ from 'lodash'

  export default {
    name: 'AscFeeSchedulesCodes',

    components: { LoadingModal, AscFeeScheduleCodesModal, Paginator, ConfirmModal },

    mixins: [ErrorsMixin],

    props: {
      id: {
        type: Number,
        required: true
      }
    },

    data () {
      return {
        isLoading: true,
        errors: [],
        showingAscFeeScheduleCodeModal: false,
        editingAscFeeScheduleCode: {},
        totalPages: 0,
        currentPage: 1,
        pageSize: 20,
        searchTerm: '',
        confirmingDelete: true,
        showConfirmation: false,
        feeScheduleCodeId: 0,
        feeScheduleId: 0,
        showingLoadingModal: false,
        ascFeeScheduleCodes: {
          codes: []
        },
        matchedCodes: {
          codes: []
        }
      }
    },
    methods: {
      loadData (silent = false) {
        if (!silent) {
          this.showingLoadingModal = true
        }
        const parameters = {
          pageSize: this.pageSize,
          page: this.currentPage,
          organizationAscFeeScheduleId: this.id
        }
        api.post('Dashboard/AscFeeSchedules/' + this.id + '/CodeList', parameters).then(response => {
          this.ascFeeScheduleCodes = response.data
          this.currentPage = response.data.page
          this.totalPages = Math.ceil(response.data.totalCodes / this.pageSize)
          this.showingLoadingModal = false
          this.searchCodes()
        }).catch(error => {
          this.isSaving = false
          this.showingLoadingModal = false
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
          }
        })
      },
      addAscFeeScheduleCode () {
        this.editingAscFeeScheduleCode = {}
        this.showingAscFeeScheduleCodeModal = true
      },

      editAscFeeScheduleCodes (ascFeeScheduleCode) {
        this.editingAscFeeScheduleCode = ascFeeScheduleCode
        this.showingAscFeeScheduleCodeModal = true
      },

      ascFeeScheduleCodeUpdated () {
        this.showingAscFeeScheduleCodeModal = false
        this.loadData()
      },
      confirmDelete (codeId) {
        this.showConfirmation = true
        this.feeScheduleCodeId = codeId
      },
      deleteFeeSchedule () {
        if (this.confirmingDelete) {
          api.delete('Dashboard/AscFeeSchedules/Codes/' + this.feeScheduleCodeId).then(() => {
            this.loadData()
          }).catch(error => {
            this.isSaving = false
            if (!this.$store.canHandleNetworkError(error)) {
              this.setFromApiErrorResponse(error)
            }
          })
          this.feeScheduleCodeId = 0
        }
      },
      deleteConfirmed (confirmation) {
        this.showConfirmation = false
        if (confirmation === true) {
          this.deleteFeeSchedule()
        }
      },
      searchCodes () {
        if (!this.searchTerm) {
          this.matchedCodes = []
          return
        }

        const parameters = {
          searchTerm: this.searchTerm,
          organizationAscFeeScheduleId: this.id
        }

        api.post('/Dashboard/AscFeeSchedules/CodeSearch', parameters).then(response => {

          this.matchedCodes = response.data
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.$log.error('Error attempting to search for code: ' + error.message, error)
          }
        })
      },
      formatNumber (number) {
        if (number) {
          return number.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
        }

        return '0.00'
      },
      discountEligible (eligible) {
        if (eligible === true) {
          return 'Yes'
        }
        if (eligible === false) {
          return 'No'
        }
      }
    },
    watch: {
      searchTerm: _.debounce(function (searchTerm) {
        if (searchTerm === '') {
          this.totalPages = Math.ceil(this.ascFeeScheduleCodes.totalCodes / this.pageSize)
          this.currentPage = 1
        } else {
          this.currentPage = 1
          this.totalPages = 0
        }
        this.searchCodes()
      }, 500),
      id (newValue) {
        if (newValue) {
          this.feeScheduleId = newValue
        }
      },
      currentPage (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.loadData()
        }
      }
    },
    computed: {
      filteredCodes () {
        if (this.searchTerm) {
          return this.matchedCodes.codes
        } else {
          return this.ascFeeScheduleCodes.codes
        }
      },
      confirmTitle () {
        return 'Delete Fee Schedule Code'
      },

      confirmButton () {
        if (this.confirmingDelete) {
          return 'Void'
        } else {
          return 'Check In'
        }

      },
      confirmCopy () {
        if (this.confirmingDelete) {
          return 'Are you sure you want to delete this fee schedule code?'
        }

        return ''
      }
    },

    created () {
      this.loadData()
    }
  }

</script>
 <style scoped>
 .patient-search-border {
   border: 1px solid rgb(255, 70, 0);
   border-radius: 5px;
 }

 .patient-search {
   border: none;
   border-radius: 4px 0 0 4px;
   box-shadow: none;
   padding-right: 0px;
   min-width: 220px;
   height: 36px;
 }
 </style>
